import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, track, fileUrl } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import ProductCard from "../../components/store/ProductCard";
import { btnGold } from "../../components/store/ui";

export default function Home() {
  const { locale, site } = useApp();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/store/products", { params: { market: locale.market, sort: "new" } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
    track("page_view", { market: locale.market });
  }, [locale.market]);
  return (
    <div>
      <section className="max-w-7xl mx-auto px-5 md:px-10 pt-10 pb-24 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 rise">
          <div className="label-xs mb-8">{site.tagline}</div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl leading-[1.02]" data-testid="hero-title">{site.hero_title}</h1>
          <p className="mt-8 text-base text-muted-foreground max-w-md leading-relaxed" data-testid="hero-subtitle">{site.hero_subtitle}</p>
          <Link to="/shop" data-testid="hero-cta" className={`${btnGold} inline-flex items-center gap-3 mt-12 tracking-[0.15em] uppercase text-xs`}>Découvrir la collection <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="lg:col-span-6 rise" style={{ animationDelay: "120ms" }}>
          <div className="aspect-[4/5] overflow-hidden bg-[#14161D]">{site.hero_image && <img src={fileUrl(site.hero_image, 1200)} alt="" fetchPriority="high" className="w-full h-full object-cover" data-testid="hero-image" />}</div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-10 py-10">
        <div className="flex items-end justify-between mb-10 border-b border-white/10 pb-4">
          <h2 className="text-3xl sm:text-4xl">Nouveautés</h2>
          <Link to="/shop" className="text-xs uppercase tracking-[0.2em]" data-testid="home-see-all">Tout voir</Link>
        </div>
        {items && !items.length && <p className="text-muted-foreground py-16 text-center font-display text-2xl" data-testid="home-empty">La collection est en préparation.</p>}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-14" data-testid="home-product-grid">
          {(items || []).slice(0, 8).map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20 grid md:grid-cols-3 gap-10 text-sm">
        {[["Prix transparents", "Prix affichés avant taxes ; TPS et TVQ détaillées avant le paiement. Jamais de faux rabais."], ["Sélection exigeante", "Chaque objet est vérifié : caractéristiques confirmées, prix fournisseur contrôlé."], ["Retours simples", "Demande de retour en ligne, suivi de votre remboursement depuis votre compte."]].map(([h, p]) => (
          <div key={h}><h3 className="text-2xl mb-3">{h}</h3><p className="text-muted-foreground leading-relaxed">{p}</p></div>
        ))}
      </section>
    </div>
  );
}
